export default __webpack_public_path__ + "static/media/send.ff0fd93a.png";